<script setup lang="ts">
import type { ContentBlockHeading } from '@nimbus/types'

const props = defineProps<ContentBlockHeading>()
</script>

<template>
    <component
        :is="`h${props.level}`"
    >
        <NimbusContentBlockRenderer :content="children" />
    </component>
</template>
